// Content for each airport / section (data-driven)

export const AIRPORTS = [
  { id: "services", code: "SRV", label: "SERVICES", color: "#E94B4B",
    position: [-30, 0, -145], runwayRot: 0.15,
    intro: "What GREINCH builds. Six pillars of B2B commerce and brokerage." },
  { id: "industries", code: "IND", label: "INDUSTRIES", color: "#F0A020",
    position: [125, 0, -55], runwayRot: -0.35,
    intro: "Where we operate. Sectors where discipline meets scale." },
  { id: "process", code: "PRC", label: "PROCESS", color: "#8B5CF6",
    position: [55, 0, 130], runwayRot: 0.55,
    intro: "How we deliver. Five stages from discovery to global scale." },
  { id: "why", code: "WHY", label: "WHY GREINCH", color: "#22D3B4",
    position: [-115, 0, 60], runwayRot: -0.25,
    intro: "You ask. We deliver. Senior, accountable, global." },
  { id: "contact", code: "CTC", label: "CONTACT", color: "#EFE3D6",
    position: [-155, 0, -95], runwayRot: 0.9, hasPort: true,
    intro: "Start a conversation. Our team responds within one business day." },
];

export const SERVICES = [
  { title: "B2B E-commerce Platforms", body: "Custom B2B portals with tiered pricing, quote workflows, contract catalogs and multi-account management." },
  { title: "API & Integrations", body: "Robust REST/GraphQL APIs and event-driven pipelines connecting every system in your commerce stack." },
  { title: "ERP / CRM Connections", body: "SAP, Oracle, Dynamics, Salesforce, HubSpot — back-office wired to storefront with discipline." },
  { title: "Brokerage & Intermediation", body: "We connect you with vetted suppliers, distributors and partners across markets and close the loop with technology." },
  { title: "Payments & Logistics", body: "Cross-border payments, taxes, carriers and customs flows wired for predictable global fulfillment." },
  { title: "Custom Web & Mobile", body: "Performance-obsessed web apps and native-grade mobile experiences for partners, ops and field teams." },
];

export const INDUSTRIES = [
  "Manufacturing",
  "Logistics & Supply Chain",
  "Finance & Fintech",
  "Energy & Utilities",
  "Content & Media Creators",
  "Social Media",
];

export const PROCESS = [
  { step: "01", label: "Discover", body: "We map your stack, buyers, partners and constraints. No assumptions." },
  { step: "02", label: "Strategy", body: "We define scope, architecture, partner network and outcomes." },
  { step: "03", label: "Design", body: "Strong, accessible interfaces and contracts for how B2B users actually operate." },
  { step: "04", label: "Develop", body: "Our senior team ships in tight increments with reviews and observability." },
  { step: "05", label: "Deploy & Scale", body: "We launch, harden and stay on — growing platform and partners with you." },
];

export const WHY = [
  { title: "Architecture-first", body: "We design for scale, security and integration before writing the first line of business logic." },
  { title: "Integration depth", body: "ERP, CRM, payments, tax, logistics, identity — we have done it, and will do it for you." },
  { title: "Observability built-in", body: "Performance, errors, business KPIs — instrumented from day one." },
  { title: "Clear communication", body: "You always know what we are building, why, and when it ships." },
];

export const CONTACT_INFO = {
  email: "hello@greinchww.com",
  address1: "2106 House Ave, Suite 741",
  address2: "Cheyenne, Wyoming, 82001 USA",
};
